import { gql } from "@apollo/client";

export const CHECK_RESET_PWD_HASH_QUERY = gql`
    query checkResetPwdHash($email: String, $hash: String) {
        checkResetPwdHash(email: $email, hash: $hash)
    }
`